/* <soh-modal id="…">: opened by any [data-modal-open="id"]; closes on backdrop, [data-modal-close], Esc. Used for Supplement Facts, video, gallery expand. */
class SohModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.soh-modal__dialog');
    document.querySelectorAll('[data-modal-open="' + this.id + '"]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); this.open(b); }));
    this.addEventListener('click', (e) => { if (e.target === this || e.target.closest('[data-modal-close]')) this.close(); });
    this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
  }
  open(opener) { this.opener = opener || document.activeElement; this.setAttribute('open', ''); SOH.lockScroll(true); this.release = SOH.trapFocus(this.dialog); this.querySelector('video')?.play().catch(() => {}); }
  close() { this.removeAttribute('open'); SOH.lockScroll(false); this.release && this.release(); this.querySelector('video')?.pause(); this.opener && this.opener.focus(); }
}
customElements.define('soh-modal', SohModal);
